"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var bootstrap_1 = require("bootstrap");
var constants_1 = require("../data/constants");
var NavbarMain = /** @class */ (function (_super) {
    __extends(NavbarMain, _super);
    function NavbarMain() {
        var _this = _super.call(this, constants_1.DATA_NAVBAR_MAIN) || this;
        _this.navbarElement = _this.getElement();
        if (!_this.navbarElement)
            return _this;
        _this.bodyContent = document.querySelector("[".concat(constants_1.DATA_BODY_CONTENT, "]"));
        NavbarMain.headerElement = _this.navbarElement.parentElement;
        _this.navbarMainButton = _this.getChildElement("[".concat(constants_1.DATA_NAVBAR_MAIN_BUTTON, "]"));
        _this.navbarMainLogo = _this.getChildElement("[".concat(constants_1.DATA_NAVBAR_MAIN_LOGO, "]"));
        new bootstrap_1.Collapse(_this.navbarElement, {
            toggle: false,
        });
        _this.mainButtonClick();
        _this.documentScroll();
        return _this;
    }
    NavbarMain.prototype.documentScroll = function () {
        var _this = this;
        document === null || document === void 0 ? void 0 : document.addEventListener('scroll', function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            (_a = _this.navbarElement) === null || _a === void 0 ? void 0 : _a.style.setProperty('--transition-delay', '0s');
            if (((_b = document === null || document === void 0 ? void 0 : document.documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop) > 0) {
                (_c = NavbarMain.headerElement) === null || _c === void 0 ? void 0 : _c.classList.add('fixed-top');
                (_d = _this.navbarElement) === null || _d === void 0 ? void 0 : _d.classList.add('is-sticky');
                (_e = _this.navbarMainLogo) === null || _e === void 0 ? void 0 : _e.classList.add('logo--w');
                if (_this.bodyContent)
                    _this.bodyContent.style.paddingTop = "".concat(NavbarMain.headerElement.offsetHeight, "px");
                return;
            }
            (_f = NavbarMain.headerElement) === null || _f === void 0 ? void 0 : _f.classList.remove('fixed-top');
            if (_this.bodyContent)
                _this.bodyContent.style.paddingTop = '';
            (_g = _this.navbarElement) === null || _g === void 0 ? void 0 : _g.classList.remove('is-sticky');
            (_h = _this.navbarMainLogo) === null || _h === void 0 ? void 0 : _h.classList.remove('logo--w');
        });
    };
    NavbarMain.prototype.mainButtonClick = function () {
        var _this = this;
        var _a;
        (_a = this.navbarMainButton) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            var _a;
            if (((_a = _this.navbarElement) === null || _a === void 0 ? void 0 : _a.classList.contains('is-open')) && document.documentElement.classList.contains('nav-is-open')) {
                _this.resetAdjustments();
            }
            else {
                _this.adjustDialog();
            }
        });
    };
    NavbarMain.prototype.adjustDialog = function () {
        var _a, _b, _c;
        var tolerance = 2 * 16;
        var width = Math.pow((window.innerWidth + tolerance), 2);
        var height = Math.pow((window.innerHeight + tolerance), 2);
        var circleRadius = Math.ceil(Math.sqrt(width + height));
        (_a = this.navbarElement) === null || _a === void 0 ? void 0 : _a.style.setProperty('--dimension', "".concat((circleRadius + 10) * 2, "px"));
        (_b = this.navbarElement) === null || _b === void 0 ? void 0 : _b.style.setProperty('--transition-delay', '0s');
        (_c = this.navbarElement) === null || _c === void 0 ? void 0 : _c.classList.add('is-open');
        document.documentElement.classList.add('nav-is-open');
    };
    NavbarMain.prototype.resetAdjustments = function () {
        var _a, _b, _c;
        (_a = this.navbarElement) === null || _a === void 0 ? void 0 : _a.style.setProperty('--dimension', '3.2rem');
        (_b = this.navbarElement) === null || _b === void 0 ? void 0 : _b.style.setProperty('--transition-delay', '.1s');
        (_c = this.navbarElement) === null || _c === void 0 ? void 0 : _c.classList.remove('is-open');
        document.documentElement.classList.remove('nav-is-open');
    };
    return NavbarMain;
}(abstractComponent_1.default));
exports.default = NavbarMain;
